import { watch } from 'vue'
import { resynchronisations } from '@/api/realtime'

/**
 * Relit les données d'un écran quand le canal temps réel REPREND après une
 * coupure ou une rotation de jeton.
 *
 * Le serveur ne rejoue rien : les événements émis pendant la coupure sont
 * perdus. Sans cette relecture, le badge « reconnexion » disparaît et la
 * liste, la fiche ouverte, les totaux ou les widgets restent sur l'état
 * d'avant — sans rien qui le signale. Tout écran qui s'abonne à des événements
 * de données (`useRealtimeTopic`) se branche aussi ici.
 *
 * `watch` dans la portée de l'appelant : arrêté avec elle, comme l'abonnement.
 */
export function useApresReconnexion(relire: () => void): void {
  watch(resynchronisations, () => relire())
}
